export function init(){
  const characters = {'ß':'%DF','ü':'%FC','ö':'%F6','ä':'%E4','Ü':'%DC','Ö':'%D6','Ä':'%C4'};
  const link = $('a.reex-summary__link--dhl').attr('href');
  const newlink = link.replace(/[ßüöäÜÖÄ]/g, m => characters[m]);
  $('a.reex-summary__link--dhl').attr('href', newlink);
};



// WEBPACK FOOTER //
// ./src/modules-es5/account/order/dhlLinkCharacter.js